import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-172" data-mp="28f80yjn3pvsp">
      <div className="mx-auto max-w-5xl px-4" data-id="element-173" data-mp="28ddhl9rhabqq">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-174" data-mp="2d6zvt6dainon">Más resultados reales</p>
        <h2 id="results-title" className="mt-3 text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-175" data-mp="2h709goskeuun">
          Docentes que ya cambiaron su forma de enseñar
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-176" data-mp="2r5fymm817u1i">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-col rounded-2xl border border-line bg-mist p-6" data-id="element-177" data-mp="2w4134xubgzvr" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-aqua" data-id="element-178" data-mp="3im7k06dv5cmu" />
              <blockquote className="mt-4 flex-1 text-sm italic leading-relaxed text-muted" data-id="element-179" data-mp="3ikmremb403rm">“{quote}”</blockquote>
              <div className="mt-5 flex items-center gap-3 border-t border-line pt-4" data-id="element-180" data-mp="3dla7oafjbct9">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-petrol text-sm font-extrabold text-white" data-id="element-181" data-mp="38mgs8cgotbqg">
                  {initials}
                </span>
                <span data-id="element-182" data-mp="58masvb2cb0j">
                  <b className="block text-sm text-ink" data-id="element-183" data-mp="8q7yze3qpmk">{name}</b>
                  <small className="text-xs text-muted" data-id="element-184" data-mp="75gjin33msx">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}